import { Dispatch } from "redux";
import {QuickbetXAction, QuickbetXActionTypes} from "../../types/QuickbetX/quickbetXTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuickbetXData = (id: string): any => {
    return async (dispatch: Dispatch<QuickbetXAction>) => {
        try {
            dispatch({ type: QuickbetXActionTypes.FETCH_QUICKBET_X_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/quickbetx_cards/${id}`,
                withCredentials: false
            });

            dispatch({ type: QuickbetXActionTypes.FETCH_QUICKBET_X_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetXActionTypes.FETCH_QUICKBET_X_DATA_ERROR, payload: errorPayload });
        }
    }
}
